import { PageRegistrationProperties } from "../../../core/reducers/pageRegistrationReducer.types";
import {
  Button,
  Divider,
  Grid,
  Tooltip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "../../../common/utils/mui-imports";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useRef, useState } from "react";
import "../../layouts/audit-layout/audit-view-main.scss";
import HPRDropDownSingleSelect from "../../../components/common/HPRDropDownSingleSelect/HPRDropDownSingleSelect";
import HPRTextBox from "../../../components/common/HPRTextBox/HPRTextBox";
import { EnumTextBoxType } from "../../../components/common/HPRTextBox/HPRTextBox.enum";
import {
  DropDownDTO,
  InspectionMemberDTO,
  InspectionStandardDTO,
  QuestionnaireDTO,
  QuestionnaireStartDTO,
  StandardReferenceDTO,
  StandardSmeDTO,
} from "../../../common/types/common.dto.types";
import usePageRegistration from "../../../core/hooks/usePageRegistration";
import {
  EnumInspectionStandardStatus,
  EnumPageMode,
  EnumPageType,
} from "../../../common/enums/common.enums";
import {
  PageModeType,
  RedirectObject,
} from "../../../common/types/common.page.type";
import SimpleReactValidator from "simple-react-validator";
import {
  QuestionnaireStartPageParametersTypes,
  QuestionnaireStartPageType,
} from "./QuestionnaireStartPage.types";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../core/hooks";
import {
  getQuestionnaireStartDropdowns,
  startQuestionnaire,
} from "./QuestionnaireStartPage.action";
import {
  changePageMode,
  clearPageModeRedirectMode,
  clearPageState,
  pausePage,
  resetPage,
  setInitState,
  setNavigateToInspectionStandards,
} from "./QuestionnaireStartPage.reducer";
import HPRLinedTextArea from "../../../components/common/HPRLinedTextArea/HPRLinedTextArea";
import { EnumLinedTextAreaType } from "../../../components/common/HPRLinedTextArea/HPRLinedTextArea.enum";
import {
  ArrowLeft2,
  ArrowRight2,
  CloseCircle,
  DirectInbox,
  Edit,
  Pointer,
  Copy,
  TickCircle,
} from "iconsax-react";
import { PopupProps } from "../../../components/Popups/PopupProps.types";
import { EnumPopupType } from "../../../components/Popups/Popup.enum";
import { openPopup } from "../../../components/Popups/Popup.reducer";
import { UsePromptTypes } from "../../../core/hooks/use-prompt/use-prompt.types";
import { usePrompt } from "../../../core/hooks/use-prompt/use-prompt";
import {
  EnumSystemFunctionTypes,
  EnumSystemFunctions,
} from "../../../core/reducers/functionRights.types";
import { CheckFunctionRights } from "../../../common/functions/common.functions";
import MultipleSelectorWithSearch from "../../../components/common/MultipleSelectorWithSearch/MultipleSelectorWithSearch";

const QuestionnaireStartPage = (props: PageRegistrationProperties) => {
  usePageRegistration(props);

  const initialState = {
    QuestionnaireStart: {
      StandardId: 0,
      InspectionId: 0,
      SelectedBuildingId: 0,
      Location: "",
      RelatedEntity: "",
      TeamMembers: "",
      GlobalPrimarySme: {} as StandardSmeDTO,
      GlobalSecondarySmes: [] as StandardSmeDTO[],
      References: [] as StandardReferenceDTO[],
      InspectionMember: {} as InspectionMemberDTO,
      InspectionStandard: {} as InspectionStandardDTO,
      BuildingList: [] as Array<DropDownDTO>,
      QuestionnaireStarted: false,
      ReferenceID: 0,
    } as QuestionnaireStartDTO,
    IsLoading: false,
    PageMode: {
      IsDisable: false,
      IsShowSaveBtn: false,
      IsShowCloseBtn: false,
      IsShowUpdateBtn: false,
      IsShowCancelBtn: false,
      IsShowDraftBtn: false,
      IsShowEditBtn: false,
      IsShowPublishedBtn: false,
      PageMode: EnumPageMode.Default,
      RedirctOption: {
        NavigateURl: "",
        NavigateObject: {} as any,
      } as RedirectObject,
    } as PageModeType,
    Validator: new SimpleReactValidator({
      messages: {
        default: "This field is required",
      },
    }),
    SourceValidator: new SimpleReactValidator({
      messages: {
        default: "This field is required.",
      },
    }),
    ShowErrorMsg: false,
    IsEditableFieldVisible: true,
  } as QuestionnaireStartPageType;

  const [questionnaireStartPageState, setQuestionnaireStartPageState] =
    useState(initialState);
  const [accordionExpanded, setAccordionExpanded] = useState({
    supportingDetails: false,
    references: true,
  });

  const [noteField, setNoteField] = useState(
    "Note: You can view all questions by pressing Start/ Continue."
  );

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setAccordionExpanded({
      ...accordionExpanded,
      [panel]: isExpanded,
    });
  };

  const authState = useAppSelector((state) => state.authReducer);

  //-----standard list heigh ------
  const mainHeading = useRef(null);
  // const wrapperCard = useRef(null);

  //Set Hight

  const [questionStartHeight, setQuestionStartHeight] = useState(0);

  useEffect(() => {
    let questionStartHeight =
      window.innerHeight - mainHeading?.current?.offsetHeight - 111;
    setQuestionStartHeight(questionStartHeight);

    function handleResize() {
      let questionStartHeight =
        window.innerHeight - mainHeading?.current?.offsetHeight - 111;
      setQuestionStartHeight(questionStartHeight);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mainHeading?.current?.offsetHeight]);

  // use for page navigation
  const navigate = useNavigate();
  const [isDirty, setIsDirty] = useState(false);
  const prompt = {
    Message: "Do you want to discard the changes?",
    When: isDirty,
  } as UsePromptTypes;
  usePrompt(prompt);
  // pass parameters from outside to page
  const location = useLocation();
  const parameter: QuestionnaireStartPageParametersTypes = location.state;

  // reducer functions
  const questionnaireStartState = useAppSelector(
    (state) => state.questionnaireStartReducer
  );
  const dispatch = useAppDispatch();
  const [selectedParameterType, setSelectedParameterType] = useState(0);
  const [allQuestionParameterList, setAllQuestionParameterList] = useState<
    DropDownDTO[]
  >([]);
  const [sourcesList, setSourcesList] = useState<DropDownDTO[]>([]);
  const [sourceName, setSourceName] = useState("");
  const [selectedSourcesList, setSelectedSourcesList] = useState<
    Array<DropDownDTO>
  >([]);

  // check when one time call to get location data from backend
  const dataFetchedRef = useRef(false);

  //On back button click
  function BackOnClickFunction() {
    navigate("/locations");
  }

  const onLocationChange = (name: string, value: any) => {
    setQuestionnaireStartPageState((values) => {
      return {
        ...values,
        QuestionnaireStart: {
          ...values.QuestionnaireStart,
          Location: value,
        },
      };
    });
  };

  const IsPageValid = (): boolean => {
    //check form valid
    let isValid = questionnaireStartPageState.Validator.allValid();
    isValid =
      selectedParameterType == 0
        ? true
        : selectedParameterType > 0 && selectedSourcesList.length > 0;

    if (!isValid) {
      setQuestionnaireStartPageState((values) => {
        return {
          ...values,
          ShowErrorMsg: !questionnaireStartPageState.ShowErrorMsg,
        };
      });

      //show validation message
      questionnaireStartPageState.Validator.showMessages();
      questionnaireStartPageState.SourceValidator.showMessages();
    } else {
      //hide validation message
      questionnaireStartPageState.Validator.hideMessages();
      questionnaireStartPageState.SourceValidator.hideMessages();
    }

    return isValid;
  };

  const onRelatedEntityChange = (name: string, value: any) => {
    setQuestionnaireStartPageState((values) => {
      return {
        ...values,
        QuestionnaireStart: {
          ...values.QuestionnaireStart,
          RelatedEntity: value,
        },
      };
    });
  };
  const onTeamMembersChange = (name: string, value: string) => {
    setQuestionnaireStartPageState((values) => {
      return {
        ...values,
        QuestionnaireStart: {
          ...values.QuestionnaireStart,
          TeamMembers: value,
        },
      };
    });
  };
  const onCopySiteMembers = () => {
    onTeamMembersChange(
      "TeamMembers",
      questionnaireStartState.QuestionnaireStart.InspectionMember.MemberName
    );
  };

  const [startClicked, setStartClicked] = useState(false);

  const onClickStart = (isStartFirstTime: boolean) => {
    let requestValues = questionnaireStartPageState.QuestionnaireStart;
    requestValues.ReferenceID = 0;
    requestValues.SelectedSourceType = selectedParameterType;
    requestValues.SelectedSources = selectedSourcesList.map((i) =>
      Number(i.Value)
    );

    if (IsPageValid()) {
      setStartClicked(true);
      setIsDirty(false);
      dispatch(startQuestionnaire(requestValues));
      // console.log(questionnaireStartPageState.QuestionnaireStart);
    } else {
      // console.log("invalid page");
    }
  };

  const onDropDownChange = (
    selectOption: DropDownDTO[],
    selectedValue: string,
    name?: string
  ) => {
    setQuestionnaireStartPageState((values) => {
      return {
        ...values,
        QuestionnaireStart: {
          ...values.QuestionnaireStart,
          SelectedBuildingId: parseInt(selectedValue),
          BuildingList: selectOption,
        },
      };
    });
  };

  const onParameterTypeDropDownChange = (
    selectOption: DropDownDTO[],
    selectedValue: string,
    name?: string
  ) => {
    if (selectedValue !== "") {
      setSelectedParameterType(parseInt(selectedValue));
      setAllQuestionParameterList(selectOption);
      const parameterList =
        questionnaireStartState.QuestionnaireStart?.QuestionParameterData
          ?.ParametersLists;

      const source = parameterList.find(
        (i) => i.TypeId == parseInt(selectedValue)
      );

      if (source && source.Items.length > 0) {
        const dropdownItems: DropDownDTO[] = source.Items.map((p: any) => ({
          Value: p.Id.toString(),
          Label: p.Name,
        }));

        setSourceName(source.Name);
        setSourcesList(dropdownItems);

        if (selectedParameterType != parseInt(selectedValue)) {
          setSelectedSourcesList([]);
        }
      }
      setNoteField(
        "Note: Please select at least one filter to Start/ Continue."
      );
    } else {
      setSelectedParameterType(0);
      setSourceName("");
      setSourcesList([]);
      setSelectedSourcesList([]);
      setNoteField(
        "Note: You can view all questions by pressing Start/ Continue."
      );
      questionnaireStartPageState.Validator.hideMessages();
      questionnaireStartPageState.SourceValidator.hideMessages();
    }
  };

  const onSelectedSourcesChangeCallBack = (
    seletedQuestionChoiseGap: Array<string>
  ) => {
    const selectedObjects = sourcesList.filter((s) =>
      seletedQuestionChoiseGap.includes(s.Value)
    );
    setSelectedSourcesList(selectedObjects);
  };

  useEffect(() => {
    questionnairePagevalidation();
  }, [questionnaireStartPageState]);

  useEffect(() => {
    dispatch(pausePage());
    if (parameter?.StandardId < 0 || parameter?.StandardId === undefined) {
      //Clear previous state
      dispatch(setInitState());
      //// console.log(parameter);
    } else {
      //// console.log(parameter);
      //Clear previous state
      dispatch(setInitState());

      dispatch(
        getQuestionnaireStartDropdowns({
          ...initialState.QuestionnaireStart,
          StandardId: parameter.StandardId,
          InspectionId: parameter.InspectionId,
          InspectionStandardId: parameter.InspectionStandardId,
        })
      );
      dispatch(changePageMode(EnumPageMode.EditMode));
    }
  }, []);

  useEffect(() => {
    const { PageMode } = questionnaireStartState;
    const { NavigateURl, NavigateObject } =
      PageMode?.RedirctOption ?? ({} as RedirectObject);

    if (
      NavigateURl !== "" &&
      NavigateURl !== undefined &&
      NavigateURl !== null
    ) {
      navigate(NavigateURl, NavigateObject);
      dispatch(clearPageModeRedirectMode());
      dispatch(clearPageState());
    }

    setQuestionnaireStartPageState((values) => {
      return {
        ...values,
        QuestionnaireStart: {
          ...values.QuestionnaireStart,
          StandardId: questionnaireStartState.QuestionnaireStart.StandardId,
          InspectionId: questionnaireStartState.QuestionnaireStart.InspectionId,
          InspectionStandardId:
            questionnaireStartState.QuestionnaireStart.InspectionStandardId,
          SelectedBuildingId:
            questionnaireStartState.QuestionnaireStart?.SelectedBuildingId,
          Location: questionnaireStartState.QuestionnaireStart?.Location,
          RelatedEntity:
            questionnaireStartState.QuestionnaireStart?.RelatedEntity,
          TeamMembers: questionnaireStartState.QuestionnaireStart?.TeamMembers,
          InspectionMember:
            questionnaireStartState.QuestionnaireStart.InspectionMember,
          InspectionStandard:
            questionnaireStartState.QuestionnaireStart.InspectionStandard,
          GlobalPrimarySme:
            questionnaireStartState.QuestionnaireStart.GlobalPrimarySme,
          BuildingList: questionnaireStartState.QuestionnaireStart.BuildingList,
          StatusId: questionnaireStartState.QuestionnaireStart.StatusId,
        },
        IsEditableFieldVisible: questionnaireStartState.IsEditableFieldVisible,
      };
    });
  }, [questionnaireStartState]);

  useEffect(() => {
    if (
      questionnaireStartState.QuestionnaireStart.QuestionnaireStarted &&
      startClicked
    ) {
      navigate("/questionnaire", {
        state: {
          SiteInspectionID:
            questionnaireStartPageState.QuestionnaireStart.InspectionId,
          StandardID: questionnaireStartPageState.QuestionnaireStart.StandardId,
          InspectionStandardId:
            questionnaireStartPageState.QuestionnaireStart.InspectionStandardId,
          QuestionnaireStarted: true,
          ReferenceID:
            questionnaireStartPageState.QuestionnaireStart.ReferenceID,
          InspectionStandardName: parameter.Title,
          SelectedSourceType: selectedParameterType,
          SelectedSources: selectedSourcesList.map((i) => Number(i.Value)),
        } as QuestionnaireDTO,
      });
    }
  }, [
    questionnaireStartState.QuestionnaireStart.QuestionnaireStarted,
    startClicked,
  ]);

  useEffect(() => {
    if (
      startClicked &&
      questionnaireStartState.QuestionnaireStart.QuestionnaireAlreadyStarted
    ) {
      dispatch(
        openPopup({
          Open: true,
          BodyText: "This questionnaire has been started by another user",
          HeaderText: "Warning",
          PopupType: EnumPopupType.WarningPopup,
          OkBtnClick() {
            navigate("/questionnaire", {
              state: {
                SiteInspectionID:
                  questionnaireStartPageState.QuestionnaireStart.InspectionId,
                StandardID:
                  questionnaireStartPageState.QuestionnaireStart.StandardId,
                InspectionStandardId:
                  questionnaireStartPageState.QuestionnaireStart
                    .InspectionStandardId,
                QuestionnaireStarted: true,
                ReferenceID:
                  questionnaireStartPageState.QuestionnaireStart.ReferenceID,
                InspectionStandardName: parameter.Title,
                SelectedSourceType: selectedParameterType,
                SelectedSources: selectedSourcesList.map((i) =>
                  Number(i.Value)
                ),
              } as QuestionnaireDTO,
            });
          },
        } as PopupProps)
      );
    }
  }, [
    questionnaireStartState.QuestionnaireStart.QuestionnaireAlreadyStarted,
    startClicked,
  ]);

  /**
   * @description check if the page is already started offline and navigate to inspection standards page
   */
  useEffect(() => {
    if (questionnaireStartState.NavigateToInspectionStandards) {
      dispatch(
        openPopup({
          Open: true,
          BodyText: questionnaireStartState.TempHasAlreadyStartedMessage ?? "",
          HeaderText: "Warning",
          PopupType: EnumPopupType.WarningPopup,
          OkBtnClick() {
            navigate("/siteInspectionStart", {
              state: {
                InspectionId: parameter.InspectionId,
              },
            });

            dispatch(
              setNavigateToInspectionStandards({
                navigateToInspectionStadnards: false,
                tempMessage: "",
              })
            );
          },
        } as PopupProps)
      );
    }
  }, [questionnaireStartState.NavigateToInspectionStandards]);

  useEffect(() => {
    const parameterList =
      questionnaireStartState.QuestionnaireStart?.QuestionParameterData
        ?.ParametersLists;

    if (parameterList && parameterList.length > 0) {
      const dropdownItems: DropDownDTO[] = parameterList
        .filter((i) => i.Items.length > 0)
        .map((p: any) => ({
          Value: p.TypeId.toString(),
          Label: p.Name,
        }));

      setAllQuestionParameterList(dropdownItems);
    }
  }, [questionnaireStartState.QuestionnaireStart.QuestionParameterData]);

  const questionnairePagevalidation = () => {
    if (
      questionnaireStartState.QuestionnaireStart?.TeamMembers !==
        questionnaireStartPageState.QuestionnaireStart?.TeamMembers ||
      questionnaireStartState.QuestionnaireStart?.Location !==
        questionnaireStartPageState.QuestionnaireStart?.Location ||
      questionnaireStartState.QuestionnaireStart?.BuildingList !==
        questionnaireStartPageState.QuestionnaireStart?.BuildingList ||
      questionnaireStartState.QuestionnaireStart?.RelatedEntity !==
        questionnaireStartPageState.QuestionnaireStart?.RelatedEntity
    ) {
      setIsDirty(true);
    } else {
      setIsDirty(false);
    }
  };

  const BacktnOnclick = () => {
    const tempisDirty = isDirty;

    if (
      questionnaireStartState.QuestionnaireStart?.TeamMembers !==
        questionnaireStartPageState.QuestionnaireStart?.TeamMembers ||
      questionnaireStartState.QuestionnaireStart?.Location !==
        questionnaireStartPageState.QuestionnaireStart?.Location ||
      questionnaireStartState.QuestionnaireStart?.RelatedEntity !==
        questionnaireStartPageState.QuestionnaireStart?.RelatedEntity
    ) {
      setIsDirty(false);
      dispatch(
        openPopup({
          Open: true,
          BodyText: "Do you want to discard the changes?",
          HeaderText: "Confirmation",
          PopupType: EnumPopupType.YesNoConfirmation,
          YesBtnClick() {
            setIsDirty(false);
            navigate("/siteInspectionStart", {
              state: {
                InspectionId: parameter.InspectionId,
              },
            });
          },
          NoBtnClick() {
            setIsDirty(tempisDirty);
          },
        } as PopupProps)
      );
    } else {
      navigate("/siteInspectionStart", {
        state: {
          InspectionId: parameter.InspectionId,
        },
      });
    }
  };

  const onChangeReference = (Id: number) => {
    if (
      questionnaireStartPageState.QuestionnaireStart.StatusId !==
      EnumInspectionStandardStatus.Intial
    ) {
      if (IsPageValid()) {
        if (isDirty) {
          dispatch(
            openPopup({
              Open: true,
              BodyText: "Do you want to discard the changes?",
              HeaderText: "Confirmation",
              PopupType: EnumPopupType.YesNoConfirmation,
              YesBtnClick() {
                setIsDirty(false);
                setStartClicked(true);
                setQuestionnaireStartPageState((values) => {
                  return {
                    ...values,
                    QuestionnaireStart: {
                      ...values.QuestionnaireStart,
                      ReferenceID: Id,
                      TeamMembers:
                        questionnaireStartState.QuestionnaireStart.TeamMembers,
                      SelectedBuildingId:
                        questionnaireStartState.QuestionnaireStart
                          .SelectedBuildingId,
                      BuildingList:
                        questionnaireStartState.QuestionnaireStart.BuildingList,
                      Location:
                        questionnaireStartState.QuestionnaireStart.Location,
                      RelatedEntity:
                        questionnaireStartState.QuestionnaireStart
                          .RelatedEntity,
                    },
                  };
                });

                dispatch(
                  startQuestionnaire({
                    ...questionnaireStartPageState.QuestionnaireStart,
                    ReferenceID: Id,
                    TeamMembers:
                      questionnaireStartState.QuestionnaireStart.TeamMembers,
                    SelectedBuildingId:
                      questionnaireStartState.QuestionnaireStart
                        .SelectedBuildingId,
                    BuildingList:
                      questionnaireStartState.QuestionnaireStart.BuildingList,
                    Location:
                      questionnaireStartState.QuestionnaireStart.Location,
                    RelatedEntity:
                      questionnaireStartState.QuestionnaireStart.RelatedEntity,
                  })
                );

                // console.log(questionnaireStartPageState.QuestionnaireStart);
              },
            } as PopupProps)
          );
        } else {
          setStartClicked(true);
          setQuestionnaireStartPageState((values) => {
            return {
              ...values,
              QuestionnaireStart: {
                ...values.QuestionnaireStart,
                ReferenceID: Id,
              },
            };
          });

          dispatch(
            startQuestionnaire({
              ...questionnaireStartPageState.QuestionnaireStart,
              ReferenceID: Id,
            })
          );

          // console.log(questionnaireStartPageState.QuestionnaireStart);
        }
      } else {
        // console.log("invalid page");
      }
    }
  };

  const onClickEditBtn = () => {
    setQuestionnaireStartPageState((values) => {
      return {
        ...values,
        IsEditableFieldVisible: false,
      };
    });
    setIsDirty(true);
  };

  const onClickCancelBtn = () => {
    const tempisDirty = isDirty;

    if (
      questionnaireStartState.QuestionnaireStart?.TeamMembers !==
        questionnaireStartPageState.QuestionnaireStart?.TeamMembers ||
      questionnaireStartState.QuestionnaireStart?.Location !==
        questionnaireStartPageState.QuestionnaireStart?.Location ||
      questionnaireStartState.QuestionnaireStart?.RelatedEntity !==
        questionnaireStartPageState.QuestionnaireStart?.RelatedEntity
    ) {
      setIsDirty(false);
      dispatch(
        openPopup({
          Open: true,
          BodyText: "Do you want to discard the changes?",
          HeaderText: "Confirmation",
          PopupType: EnumPopupType.YesNoConfirmation,
          YesBtnClick() {
            setIsDirty(false);
            setQuestionnaireStartPageState((values) => {
              return {
                ...values,
                QuestionnaireStart: {
                  ...values.QuestionnaireStart,
                  StandardId:
                    questionnaireStartState.QuestionnaireStart.StandardId,
                  InspectionId:
                    questionnaireStartState.QuestionnaireStart.InspectionId,
                  InspectionStandardId:
                    questionnaireStartState.QuestionnaireStart
                      .InspectionStandardId,
                  SelectedBuildingId:
                    questionnaireStartState.QuestionnaireStart
                      ?.SelectedBuildingId,
                  Location:
                    questionnaireStartState.QuestionnaireStart?.Location,
                  RelatedEntity:
                    questionnaireStartState.QuestionnaireStart?.RelatedEntity,
                  TeamMembers:
                    questionnaireStartState.QuestionnaireStart?.TeamMembers,
                  InspectionMember:
                    questionnaireStartState.QuestionnaireStart.InspectionMember,
                  InspectionStandard:
                    questionnaireStartState.QuestionnaireStart
                      .InspectionStandard,
                  GlobalPrimarySme:
                    questionnaireStartState.QuestionnaireStart.GlobalPrimarySme,
                  BuildingList:
                    questionnaireStartState.QuestionnaireStart.BuildingList,
                  StatusId: questionnaireStartState.QuestionnaireStart.StatusId,
                },
                IsEditableFieldVisible: true,
              };
            });
          },
          NoBtnClick() {
            setIsDirty(tempisDirty);
          },
        } as PopupProps)
      );
    } else {
      setQuestionnaireStartPageState((values) => {
        return {
          ...values,
          QuestionnaireStart: {
            ...values.QuestionnaireStart,
            StandardId: questionnaireStartState.QuestionnaireStart.StandardId,
            InspectionId:
              questionnaireStartState.QuestionnaireStart.InspectionId,
            InspectionStandardId:
              questionnaireStartState.QuestionnaireStart.InspectionStandardId,
            SelectedBuildingId:
              questionnaireStartState.QuestionnaireStart?.SelectedBuildingId,
            Location: questionnaireStartState.QuestionnaireStart?.Location,
            RelatedEntity:
              questionnaireStartState.QuestionnaireStart?.RelatedEntity,
            TeamMembers:
              questionnaireStartState.QuestionnaireStart?.TeamMembers,
            InspectionMember:
              questionnaireStartState.QuestionnaireStart.InspectionMember,
            InspectionStandard:
              questionnaireStartState.QuestionnaireStart.InspectionStandard,
            GlobalPrimarySme:
              questionnaireStartState.QuestionnaireStart.GlobalPrimarySme,
            BuildingList:
              questionnaireStartState.QuestionnaireStart.BuildingList,
            StatusId: questionnaireStartState.QuestionnaireStart.StatusId,
          },
          IsEditableFieldVisible: true,
        };
      });
    }
  };

  const checkSystemFunctionRight = (
    functionId: EnumSystemFunctions,
    functionTypeId: EnumSystemFunctionTypes
  ): boolean => {
    return CheckFunctionRights(
      authState.FunctionRights,
      EnumPageType.SiteInspectionStart,
      functionId,
      functionTypeId
    );
  };

  const removeSelectedSource = (id: String) => {
    const updatedList = selectedSourcesList.filter((i) => i.Value != id);
    setSelectedSourcesList(updatedList);
  };

  const ClearAllFilters = () => {
    setSelectedParameterType(0);
    setSelectedSourcesList([]);
    setNoteField(
      "Note: You can view all questions by pressing Start/ Continue."
    );
    questionnaireStartPageState.Validator.hideMessages();
    questionnaireStartPageState.SourceValidator.hideMessages();
  };

  return (
    <>
      <div className="content-section-card rem-tracker top-main-padding question-start-page">
        <div
          className=" global-subhead-btn-wrap top-main-border-inner flex-wrap_wrap"
          ref={mainHeading}
        >
          <div className="global-subhead-wrap mr-auto">
            <div className="flex--container">
              <div className="flex__item--inherit pr-10">
                <a
                  style={{ display: "inline-flex" }}
                  className="cursor-pointer audit-back v-align"
                  aria-label="back"
                  title="Back to inspection page"
                  onClick={BacktnOnclick}
                >
                  {/* <ArrowLeft2 size={40} onClick={BacktnOnclick} /> */}
                  <ArrowBackIosNewOutlinedIcon className="" />
                  <span className="body-bold secondary-color flex__item--vcenter">
                    Back
                  </span>
                </a>
              </div>

              <div className="rem-trak-head-res d-flex">
                <Tooltip
                  title={
                    parameter.InspectionName
                      ? parameter.InspectionName
                      : "Title"
                  }
                  placement={"top-start"}
                >
                  <h1
                    className="page-title no-wrap limit-1"
                    style={{ maxWidth: "34vw" }}
                  >
                    {parameter.InspectionName
                      ? parameter.InspectionName
                      : "Title"}
                  </h1>
                </Tooltip>
                <span className="d-flex pl-10 pr-10 fx-align-center arrow-separator">
                  {" "}
                  <ArrowRight2
                    color="#000"
                    // style={{
                    //   paddingTop: "5px",
                    //   marginTop: "-10px",
                    // }}
                    size="24"
                  />
                </span>
                <Tooltip
                  title={parameter.Title ? parameter.Title : "Title"}
                  placement={"top-start"}
                >
                  <h1
                    className="page_title no-wrap tab-view-fnt-resize limit-1"
                    style={{ maxWidth: "38vw" }}
                  >
                    {parameter.Title ? parameter.Title : "Title"}
                  </h1>
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="d-flex ml-auto">
            <div>
              {parameter.IsContinueButtonVisible &&
              !questionnaireStartPageState.IsEditableFieldVisible ? (
                <>
                  <Button
                    className="secondary-btn-small"
                    variant="outlined"
                    disableElevation
                    onClick={onClickCancelBtn}
                    startIcon={<CloseCircle variant="Outline" />}
                  >
                    Cancel
                  </Button>
                </>
              ) : (
                <></>
              )}
            </div>
            <Button
              className="primary-btn-small"
              startIcon={<ArrowRight2 size="18" />}
              variant="contained"
              disableElevation
              onClick={() => {
                onClickStart(parameter.IsContinueButtonVisible ? false : true);
              }}
            >
              {parameter.IsContinueButtonVisible
                ? questionnaireStartPageState.IsEditableFieldVisible
                  ? "Continue"
                  : "Save and Continue"
                : "Start"}
            </Button>
            {parameter.IsContinueButtonVisible &&
            questionnaireStartPageState.IsEditableFieldVisible ? (
              <Button
                className="primary-btn-small"
                variant="contained"
                startIcon={<Edit className="mr-5" />}
                disableElevation
                style={{
                  display: "flex",
                  visibility: checkSystemFunctionRight(
                    EnumSystemFunctions.QuestionnairePage_Edit_Intermediate,
                    EnumSystemFunctionTypes.ButtonAccess
                  )
                    ? "visible"
                    : "hidden",
                }}
                onClick={onClickEditBtn}
              >
                Edit
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="pt-5">
          <Grid
            container
            spacing={3}
            className="pl-10 pr-10"
            height={questionStartHeight}
            style={{ overflowY: "auto" }}
          >
            <Grid item xl={3} lg={3} md={5} sm={12} xs={12}>
              <Grid container direction={"column"} spacing={3}>
                <Grid item>
                  <div className="item-content gray-background">
                    <div className="unstyled-list-wrapper">
                      <div className="item-header">
                        <h3>Global primary SME(s)</h3>
                      </div>
                      {questionnaireStartPageState.QuestionnaireStart
                        .GlobalPrimarySme ? (
                        <ul>
                          {questionnaireStartPageState.QuestionnaireStart
                            .GlobalPrimarySme.Sme ? (
                            <li>
                              {
                                questionnaireStartPageState.QuestionnaireStart
                                  .GlobalPrimarySme.Sme.DisplayName
                              }
                            </li>
                          ) : (
                            <></>
                          )}
                        </ul>
                      ) : (
                        <ul>
                          <li></li>
                        </ul>
                      )}
                    </div>
                  </div>
                </Grid>

                <Grid item>
                  <div className="item-content gray-background">
                    <div className="unstyled-list-wrapper">
                      <div className="item-header">
                        <h3>Global secondary SME(s)</h3>
                      </div>
                      {questionnaireStartState.QuestionnaireStart
                        .GlobalSecondarySmes ? (
                        <ul className="sme-height">
                          {questionnaireStartState.QuestionnaireStart.GlobalSecondarySmes.map(
                            (sme, index) => (
                              <li key={index + 1}>{sme.Sme.DisplayName}</li>
                            )
                          )}
                        </ul>
                      ) : (
                        <ul>
                          <li></li>
                        </ul>
                      )}
                    </div>
                  </div>
                </Grid>
                <Grid item>
                  <div className="item-content gray-background">
                    <div className="unstyled-list-wrapper">
                      <div className="item-header">
                        <h3>Site primary SME(s)</h3>
                      </div>
                      {questionnaireStartState.QuestionnaireStart
                        .InspectionStandard?.InspectionStandardSmes?.length >
                      0 ? (
                        <ul className="sme-height">
                          {questionnaireStartState.QuestionnaireStart.InspectionStandard?.InspectionStandardSmes?.map(
                            (item, index) => (
                              <li key={index + 1}>{item.Sme?.DisplayName}</li>
                            )
                          )}
                        </ul>
                      ) : (
                        <ul></ul>
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              className="summary-accordion"
              item
              xl={9}
              lg={9}
              md={7}
              sm={12}
              xs={12}
            >
              {/* Supporting Details Accordion */}
              <Accordion
                expanded={accordionExpanded.supportingDetails}
                onChange={handleAccordionChange("supportingDetails")}
                sx={{
                  marginBottom: "20px",
                  marginTop: "0",
                  boxShadow: "none",
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  className="question-accordian"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="supporting-details-content"
                  id="supporting-details-header"
                  sx={{
                    borderBottom: accordionExpanded.supportingDetails
                      ? "1px solid #e0e0e0"
                      : "none",
                    minHeight: "48px !important",
                    "& .MuiAccordionSummary-content": {
                      margin: "12px 0 !important",
                    },
                  }}
                >
                  <div className="accordion-header">Supporting Details</div>
                </AccordionSummary>
                <AccordionDetails sx={{ paddingY: "20px", paddingX: "0" }}>
                  <div className="form-group">
                    <HPRDropDownSingleSelect
                      Label={"Building"}
                      Name={"Building"}
                      Items={Object.assign(
                        [] as Array<DropDownDTO>,
                        questionnaireStartPageState.QuestionnaireStart
                          .BuildingList
                      )}
                      onDropDownChange={onDropDownChange}
                      Select={
                        questionnaireStartPageState?.QuestionnaireStart
                          ?.SelectedBuildingId
                      }
                      // Validator={questionnaireStartPageState?.Validator}
                      // IsEnableValidator={true}
                      IsSearchableWithAdd={true}
                      Disabled={
                        questionnaireStartPageState.IsEditableFieldVisible &&
                        parameter.IsContinueButtonVisible
                          ? true
                          : false
                      }
                    />
                  </div>
                  <div className="form-group">
                    <HPRTextBox
                      Id=""
                      Name="Location"
                      Label={"Location (floor, column, room, space ID, other)"}
                      Value={
                        questionnaireStartPageState.QuestionnaireStart.Location
                      }
                      onTextBoxChange={onLocationChange}
                      Type={EnumTextBoxType.Text}
                      // Validator={questionnaireStartPageState.Validator}
                      // IsEnableValidator={true}
                      Disabled={
                        questionnaireStartPageState.IsEditableFieldVisible &&
                        parameter.IsContinueButtonVisible
                          ? true
                          : false
                      }
                    ></HPRTextBox>
                  </div>
                  <div className="form-group">
                    <HPRTextBox
                      Id=""
                      Name="RelatedEntity"
                      Label={"Equipment, Application,  System or other"}
                      Value={
                        questionnaireStartPageState.QuestionnaireStart
                          .RelatedEntity
                      }
                      onTextBoxChange={onRelatedEntityChange}
                      Type={EnumTextBoxType.Text}
                      // Validator={questionnaireStartPageState.Validator}
                      // IsEnableValidator={true}
                      Disabled={
                        questionnaireStartPageState.IsEditableFieldVisible &&
                        parameter.IsContinueButtonVisible
                          ? true
                          : false
                      }
                    ></HPRTextBox>
                  </div>
                  <div className="flex--container">
                    <div className="flex__item">
                      <div className="form-group">
                        {/*<HPRTextArea
                          Id=""
                          Name="TeamMembers"
                          Label={"Team members"}
                          Value={questionnaireStartPageState.QuestionnaireStart?.TeamMembers}
                          onTextAreaChange={onTeamMembersChange}
                          Type={EnumTextAreaType.Text}
                          ClassName={"hpr-textarea"}
                        ></HPRTextArea>*/}
                        <HPRLinedTextArea
                          Id=""
                          Name="TeamMembers"
                          Label={"Team members"}
                          Value={
                            questionnaireStartPageState.QuestionnaireStart
                              ?.TeamMembers
                              ? questionnaireStartPageState.QuestionnaireStart
                                  ?.TeamMembers
                              : ""
                          }
                          onTextAreaChange={onTeamMembersChange}
                          Type={EnumLinedTextAreaType.Text}
                          ClassName={"hpr-textarea"}
                          // Validator={questionnaireStartPageState.Validator}
                          Disabled={
                            questionnaireStartPageState.IsEditableFieldVisible &&
                            parameter.IsContinueButtonVisible
                              ? true
                              : false
                          }
                          InputProps={{ maxLength: 250 }}
                          TextLength={250}
                          ShowTextCounter
                        ></HPRLinedTextArea>
                      </div>
                    </div>
                    <div className="flex__item--inherit ml-10">
                      <Button
                        className={
                          questionnaireStartPageState.IsEditableFieldVisible &&
                          parameter.IsContinueButtonVisible
                            ? "disabled rem-lined-btn capitalization-unset"
                            : "rem-lined-btn capitalization-unset"
                        }
                        variant="outlined"
                        disableElevation
                        onClick={onCopySiteMembers}
                        startIcon={<Copy variant="Outline" />}
                        style={{
                          height: "fit-content",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Copy from site team members
                      </Button>
                    </div>
                  </div>

                  {/* </div> */}
                  {/* </div> */}
                  {/* 
                        <div style={{ marginTop: 10 }} className="align-right">
                          {parameter.IsContinueButtonVisible &&
                          !questionnaireStartPageState.IsEditableFieldVisible ? (
                            <>
                              <Button
                                className="primary small-btn"
                                variant="contained"
                                disableElevation
                                style={{ display: "flex", alignSelf: "end" }}
                                onClick={onClickCancelBtn}
                              >
                                Cancel
                              </Button>
                            </>
                          ) : (
                            <></>
                          )}
                        </div> */}
                </AccordionDetails>
              </Accordion>
              {/* References Accordion */}
              {questionnaireStartState.QuestionnaireStart?.QuestionParameterData
                ?.ParametersLists &&
                questionnaireStartState.QuestionnaireStart
                  ?.QuestionParameterData?.ParametersLists.length > 0 &&
                questionnaireStartState.QuestionnaireStart?.QuestionParameterData?.ParametersLists.some(
                  (i) => i.Items.length > 0
                ) && (
                  <Accordion
                    expanded={accordionExpanded.references}
                    onChange={handleAccordionChange("references")}
                    sx={{
                      marginBottom: "20px",
                      marginTop: "0",
                      boxShadow: "none",
                      "&:before": {
                        display: "none",
                      },
                    }}
                  >
                    <AccordionSummary
                      className="question-accordian"
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="references-content"
                      id="references-header"
                      sx={{
                        borderBottom: accordionExpanded.references
                          ? "1px solid #e0e0e0"
                          : "none",
                        minHeight: "48px !important",
                        "& .MuiAccordionSummary-content": {
                          margin: "12px 0 !important",
                        },
                      }}
                    >
                      <div className="accordion-header">
                        Filter Question(s) by Sources
                      </div>
                    </AccordionSummary>
                    <AccordionDetails sx={{ paddingY: "10px", paddingX: "0" }}>
                      <p style={{ marginBottom: "20px" }}>
                        Filter by source to view related questions.
                      </p>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 2fr auto",
                          gap: "10px",
                          alignItems: "start",
                        }}
                      >
                        <HPRDropDownSingleSelect
                          Label={"Sources"}
                          Name={"Sources"}
                          Items={allQuestionParameterList}
                          onDropDownChange={onParameterTypeDropDownChange}
                          Select={selectedParameterType}
                          IsSearchableWithAdd={true}
                        />
                        {selectedParameterType !== 0 && (
                          <>
                            <MultipleSelectorWithSearch
                              Label={`${sourceName}(s)`}
                              SelectedValueArray={selectedSourcesList.map(
                                (i) => i.Value
                              )}
                              Options={sourcesList}
                              onSelectionChange={(selected: string[]): void => {
                                onSelectedSourcesChangeCallBack(selected);
                              }}
                              ButtonLabel="Ok"
                              Placeholder={`Search by ${sourceName}s`}
                              IsEnableValidator={true}
                              Validator={
                                questionnaireStartPageState?.SourceValidator
                              }
                            />
                            {selectedSourcesList.length > 0 && (
                              <Button
                                className="rem-lined-btn"
                                variant="outlined"
                                style={{
                                  height: "fit-content",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={() => ClearAllFilters()}
                              >
                                Clear All Filters
                              </Button>
                            )}
                          </>
                        )}
                      </div>

                      <p
                        style={{
                          marginTop: "10px",
                          marginBottom: "10px",
                          color: "#066fa4",
                        }}
                      >
                        {selectedSourcesList.length === 0 && noteField}
                      </p>

                      <div className="unstyled-list-wrapper">
                        {selectedSourcesList ? (
                          <ul
                            className="remove-list-style inline-item-list"
                            style={{
                              maxHeight: "150px",
                              overflowX: "hidden",
                              // overflowY: "scroll",
                              overflow: "auto",
                              // overscrollBehavior: "contain",
                            }}
                          >
                            {selectedSourcesList.length > 0 &&
                              selectedSourcesList.map((reference, index) => (
                                <li key={index}>
                                  <div style={{ display: "flex" }}>
                                    <a
                                      className="limit-1"
                                      style={{ maxWidth: "500px" }}
                                    >
                                      <Tooltip
                                        title={
                                          reference.Label ? reference.Label : ""
                                        }
                                        placement={"top-start"}
                                      >
                                        <u style={{ textDecoration: "none" }}>
                                          {reference.Label}
                                        </u>
                                      </Tooltip>
                                    </a>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      <CloseCircle
                                        size="16"
                                        cursor="Pointer"
                                        onClick={() =>
                                          removeSelectedSource(reference.Value)
                                        }
                                      />
                                    </div>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        ) : (
                          <ul></ul>
                        )}
                      </div>
                      {selectedSourcesList.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            color: "#6b9b37",
                          }}
                        >
                          <TickCircle size="18" className="mr-10" />
                          <p style={{ color: "#6b9b37" }}>
                            Filters have been applied, press Start/ Continue to
                            view the related questions. If you want to view all
                            questions, press Clear All Filters and then Start/
                            Continue.
                          </p>
                        </div>
                      )}
                    </AccordionDetails>
                  </Accordion>
                )}
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default QuestionnaireStartPage;
